// extracted by mini-css-extract-plugin
export default {"wrapper":"ConditionalsComponent_wrapper__6531E"};